var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title)?_c('span',{class:_vm.className,on:{"click":function($event){$event.preventDefault();return _vm.handleSubCategorySelected.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }